<template lang="pug">
.card.radius-card
  .card-header
    .columns.align-center
      .column #[.h5 Últimos ganhos]
      .column.col-auto #[i.fas.fa-money-bill-alt.fa-lg]
  .card-body
    highcharts(:options="options")
</template>

<script>
export default {
  props: {
    value: { type: Object, default: () => ({ labels: [], data: [] }) },
  },
  computed: {
    labels() {
      return this.value.labels.map(dateJSON => {
        const options = { year: 'numeric', month: 'long', timeZone: 'UTC' }
        const date = new Date(dateJSON)
        return date.toLocaleDateString(navigator.language, options)
      })
    },
    options() {
      return {
        title: { text: '' },
        chart: { height: 300 },
        xAxis: { categories: this.labels },
        yAxis: {
          title: { text: 'Reais (R$)' },
          plotLines: [
            {
              value: 0,
              width: 1,
              color: '#808080',
            },
          ],
        },
        series: [
          {
            name: 'Ganhos',
            tooltip: {
              valuePrefix: 'R$ ',
              valueDecimals: 2,
            },
            color: '#27ae60',
            data: this.value.data.map(v => v / 100),
          },
        ],
      }
    },
  },
}
</script>
